import { defineStore } from "pinia";
import { StateTree, _GettersTree, _ActionsTree } from "pinia";

// Interfaz del estado
interface CreditState extends StateTree {
  selectedCredit: Record<string, any> | null; // Crédito seleccionado
}

// Interfaz de getters
interface CreditGetters extends _GettersTree<CreditState> {
  getSelectedCredit: (state: CreditState) => Record<string, any> | null;
}

// Interfaz de acciones
interface CreditActions extends _ActionsTree {
  setSelectedCredit(credit: Record<string, any>): void;
  clearSelectedCredit(): void;
}

// Definición del store
export const useCreditStore = defineStore<
  "credit",
  CreditState,
  CreditGetters,
  CreditActions
>("credit", {
  // Estado inicial
  state: () => ({
    selectedCredit: null,
  }),

  // Getters
  getters: {
    getSelectedCredit: (state) => state.selectedCredit,
  },

  // Acciones
  actions: {
    // Establecer el crédito seleccionado
    setSelectedCredit(credit) {
      this.selectedCredit = credit;
    },

    // Limpiar el crédito seleccionado
    clearSelectedCredit() {
      this.selectedCredit = null;
    },
  },

  // Persistencia opcional para mantener el crédito seleccionado en el almacenamiento local
  persist: {
    storage: localStorage,
    pick: ["selectedCredit"],
  },
});
